import { connect } from 'react-redux';
import { compose } from 'recompose';
import { fetchForDashboardV2 } from '../../metrics/actions';
import resetFiltersHoc from '../../hoc/resetFiltersHoc';
import Filters from '../../filters/containers/Filters';

const DashboardFilters = compose(
  resetFiltersHoc,
  connect(
    null,
    {
      fetcher: fetchForDashboardV2,
    }
  ),
)(Filters);

export default DashboardFilters;
